import { initializeApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";

// Firebase configuration from environment variables
// Only includes essential variables for authentication
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

// Validate that all required environment variables are present
// Only the essential variables for Firebase Authentication
const requiredEnvVars = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_AUTH_DOMAIN",
  "VITE_FIREBASE_PROJECT_ID",
];

const missingVars = requiredEnvVars.filter(
  (varName) => !import.meta.env[varName],
);
if (missingVars.length > 0) {
  throw new Error(
    `Missing required environment variables: ${missingVars.join(", ")}\n\nPlease:\n1. Copy .env.example to .env\n2. Replace placeholder values with your Firebase project configuration\n3. Get these values from Firebase Console > Project Settings > General > Your apps`,
  );
}

// Check for placeholder values that haven't been replaced
const placeholderValues = [
  "your_api_key_here",
  "your_project_id.firebaseapp.com",
  "your_project_id",
];

const hasPlaceholders = Object.values(firebaseConfig).some(
  (value) =>
    typeof value === "string" &&
    placeholderValues.some((placeholder) => value.includes("your_")),
);

if (hasPlaceholders) {
  throw new Error(
    `Environment variables contain placeholder values. Please replace them with your actual Firebase configuration from Firebase Console > Project Settings > General > Your apps`,
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth: Auth = getAuth(app);

export const getAuthIdToken = async () => {
  const user = auth.currentUser;

  if (user) {
    try {
      const idToken = await user.getIdToken();
      return idToken;
    } catch (error) {
      console.error("Error getting ID token:", error);
    }
  }

  return null;
};

export default app;
